// extracted by mini-css-extract-plugin
export var auto = "_31-1";
export var spinner = "_31-0";